import React from "react";
import { BooleanField, DateField, Show, SimpleShowLayout, TextField } from "react-admin";

export const ShowComponent: React.FC = () => (
  <Show>
    <SimpleShowLayout>
      <TextField label="Id" source="id" />
      <TextField label="Name" source="name" />
      <TextField label="Serial number" source="serial_number" />
      <TextField label="Organization" source="organization.name" />
      <BooleanField label="Active" source="is_active" />
      <DateField label="Created at" source="created_at" />
      <DateField label="Updated at" source="updated_at" />
    </SimpleShowLayout>
  </Show>
);
